import React from "react";
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Link } from 'react-router-dom';
import Divider from "@mui/material/Divider";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from "@mui/material";

export default function NavBarProfile(props) {

    const menuId = 'primary-search-account-menu';

    const [anchorEl, setAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Menu
                sx={{ p: 0 }}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                id={menuId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                {sessionStorage.getItem('_GreetingMessage') && (
                    <>
                        <Typography sx={{ mx: 2, my: "6px" }} className="MuiMenuItem-gutters">{sessionStorage.getItem('_GreetingMessage')}</Typography>
                        <Divider sx={{ my: '8px' }} />
                    </>    
                )}
                <Link to="/LeoSeaPortal/logout">
                    <MenuItem
                        data-testid="headerUserDropDownLogout"
                        onClick={handleMenuClose}
                    >
                        Logout
                    </MenuItem>
                </Link>
            </Menu>

            <IconButton
                size="large"
                edge="end"
                aria-label="profile"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
            >
                <AccountCircle />
            </IconButton>
        </>
    );
}
